import KeyCloackService from '../../services/KeyCloackService';

type Props = {
    children: JSX.Element;
}

const RenderOnAuthenticated = ({ children }:Props) => (KeyCloackService.isLoggedIn()) ? children : null;

export default RenderOnAuthenticated